import apiClient from "@/lib/api-client"
import type { User, PaginatedResponse } from "@/types/api"

export const userService = {
  // Get all users (admin only)
  getUsers: async (params?: {
    limit?: number
    offset?: number
  }): Promise<PaginatedResponse<User>> => {
    const query = params ? `?${new URLSearchParams(params as any).toString()}` : ""
    return apiClient.get<PaginatedResponse<User>>(`/users/${query}`)
  },

  // Get user by ID
  getUser: async (id: number): Promise<User> => {
    return apiClient.get<User>(`/users/${id}/`)
  },

  // Update user
  updateUser: async (id: number, data: Partial<User>): Promise<User> => {
    return apiClient.patch<User>(`/users/${id}/`, data)
  },

  // Delete user
  deleteUser: async (id: number): Promise<void> => {
    await apiClient.delete(`/users/${id}/`)
  },
}
